var _circle, _circle2, _circle3, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCircleButton = function SvgCircleButton(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 14.5,
    stroke: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "loading",
    cx: 21,
    cy: 21,
    r: 17.5,
    stroke: "none"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 20.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.4238 6.42969L31.2021 10.6931M10.7968 31.2995L6.57502 35.5629",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 21L35.5 21M6.5 21L0.5 21",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50391 6.50781L10.7465 10.7505M31.2526 31.2565L35.4953 35.4992",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 1V7M21 36V42",
    stroke: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCircleButton);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iNDIiCiAgaGVpZ2h0PSI0MiIKICB2aWV3Qm94PSIwIDAgNDIgNDIiCiAgZmlsbD0ibm9uZSIKPgogIDxjaXJjbGUgY3g9IjIxIiBjeT0iMjEiIHI9IjE0LjUiIHN0cm9rZT0id2hpdGUiIC8+CiAgPGNpcmNsZSBjbGFzc05hbWU9ImxvYWRpbmciIGN4PSIyMSIgY3k9IjIxIiByPSIxNy41IiBzdHJva2U9Im5vbmUiIC8+CiAgPGNpcmNsZSBjeD0iMjEiIGN5PSIyMSIgcj0iMjAuNSIgc3Ryb2tlPSJ3aGl0ZSIgLz4KICA8cGF0aAogICAgZD0iTTM1LjQyMzggNi40Mjk2OUwzMS4yMDIxIDEwLjY5MzFNMTAuNzk2OCAzMS4yOTk1TDYuNTc1MDIgMzUuNTYyOSIKICAgIHN0cm9rZT0id2hpdGUiCiAgLz4KICA8cGF0aCBkPSJNNDEuNSAyMUwzNS41IDIxTTYuNSAyMUwwLjUgMjEiIHN0cm9rZT0id2hpdGUiIC8+CiAgPHBhdGgKICAgIGQ9Ik02LjUwMzkxIDYuNTA3ODFMMTAuNzQ2NSAxMC43NTA1TTMxLjI1MjYgMzEuMjU2NUwzNS40OTUzIDM1LjQ5OTIiCiAgICBzdHJva2U9IndoaXRlIgogIC8+CiAgPHBhdGggZD0iTTIxIDFWN00yMSAzNlY0MiIgc3Ryb2tlPSJ3aGl0ZSIgLz4KPC9zdmc+Cg==";